import { Body, Button, Heading, Icon } from "@elaniintc/goes-design-system";

interface FormSuccessScreenProps {
  formName: string;
  requestId: string;
  onNavigateBack: () => void;
}

export const FormSuccessScreen = ({
  formName,
  requestId,
  onNavigateBack,
}: FormSuccessScreenProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center h-[60vh]">
      <div className="mb-6">
        <Icon
          type="fas"
          name="circle-check"
          className="text-success-quiet! text-h0"
        />
      </div>

      <Heading variant="h4" className="text-success mb-2">
        Formulario enviado
      </Heading>

      <div className="mb-8 max-w-md">
        <Body className="text-neutral-loud">
          El formulario <span className="font-bold">{formName}</span> de la
          solicitud <span className="font-bold">{requestId}</span> ha sido
          enviado exitosamente.
        </Body>
      </div>

      <Button
        variant="quiet"
        onClick={onNavigateBack}
        className="w-full max-w-sm"
      >
        Volver al detalle de trámite
      </Button>
    </div>
  );
};
